import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";

const Loader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        position: "absolute",
        top: "50%",
        width: "100%",
        left:"0%",
        height: "100%",
        justifyContent: "center",
        alignItems: "start",
        // background: "#000",
        zIndex: 99,
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;
